import * as React from 'react'
import {Box, Typography} from '@mui/material'
import {FONT, SIZE, WEIGHT} from '../../../../styles/foundation/typography'
import {NAVY} from '../../../../styles/foundation/colors'
import {GAP} from '../../../../styles/foundation/spacing'

/**
 * One titled block inside a request card or drawer.
 *
 * RqReviewCard, RqRejectCard and RqApprovedDrawer each declared their own
 * `sectionLabelSx`, which is how the same role ended up rendering at
 * SIZE['2xs'] on the two cards and SIZE.xs in the drawer. One component
 * instead, so a section heading is one decision rather than three.
 *
 * The heading is a real `<h4>` under each card's `<h3>` title and it NAMES the
 * block, so a timeline no longer needs a visible label plus an `aria-label`
 * repeating the same words at it — the duplicate every one of those three
 * surfaces was carrying.
 */
export default function RqSection({title, children, sx}) {
  const headingId = React.useId()

  return (
    <Box component='section' aria-labelledby={headingId} sx={{minWidth: 0, ...sx}}>
      <Typography
        id={headingId}
        component='h4'
        sx={{fontFamily: FONT, fontWeight: WEIGHT.bold, fontSize: SIZE.xs, color: NAVY, m: 0, mb: GAP.xs}}
      >
        {title}
      </Typography>
      {children}
    </Box>
  )
}
